import Vue from 'vue';
import SvgIcon from '@/components/global/SvgIcon';

Vue.component('svg-icon', SvgIcon);

const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context('../assets/icons/svgs', false, /\.svg$/);
requireAll(req);
